import React, { Component } from 'react';
import IgniteDataTable from '../../common/datatable';
import { history } from '../../../store'

const columns = [
  { prop: 'id', title: 'ID', width: '100' },
  { prop: 'name', title: 'Name' },
  { prop: 'start-date', title: 'Start date' },
  { prop: 'end-date', title: 'End date' },
  { prop: 'points-paid', title: 'Points paid' }
];

const actions = [
  {
    label: 'View/Edit Reward Allocations',
    callback: (row) => {
      history.push(`/admin/outlet-reward-allocations/${row['incentives-outlets-id']}/view`);
    }
  },
];

class ActiveIncentives extends Component {
  render() {
    const { incentives } = this.props;

    return (
      <IgniteDataTable
        hasAttributes={false}
        data={incentives || []}
        columns={columns}
        actions={actions}
      />
    );
  }
}

export default ActiveIncentives;



// WEBPACK FOOTER //
// ./src/components/admin/outlet-view/active-incentives.jsx